import { Box, Paper, Typography,ButtonBase } from "@mui/material"
import { CenteredBox } from "../../components/layouts/OneViewBox"
function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}
const countParser = (count) => {
    // if (count >= 1000) {
    //     return ((count / 1000)).toFixed(1) + "k"
    // }
    const parsedCount = Number(count);

    // Check if parsedCount is a number and handle the case when count is not a number
    if (isNaN(parsedCount)) {
        return count; // Return the original value if it's not a number
    }
    return isInt(parsedCount) ? parsedCount : parsedCount.toFixed(1);
    // return isInt(count) ? count : count?.toFixed(1);  
}

const Counts = ({ title, count, active, subtitle, unit, ...props }) => {
  return (
    <Paper
      component={props.onClick ? ButtonBase : Box}
      sx={{
        height: "100%",
        width: "100%",
        bgcolor: active ? "primary.main" : "background.paper",
        color: active ? "white" : "primary.main",
        borderRadius: 2,
        transition: "all 0.3s",
        boxShadow: active ? 4 : 1,
        
      }}
      {...props}
    >
      <CenteredBox sx={{ flexDirection: "column" }}>
        <Typography
          variant="h2"
          lineHeight="150%"
          py={1}
          sx={{
            display: "flex",
            alignItems: "flex-end",
            color: active ? "white" : "primary.main",
            
          }}
        >
          {countParser(count)}{" "}
          {unit && (
            <Typography
              variant="h4"
              sx={{ ml: 0.5, color: active ? "white" : "primary.main" }}
            >
              {unit}
            </Typography>
          )}
        </Typography>

        <Typography
          variant="h6"
          align="center"
          sx={{ color: active ? "white" : "black", mb: 3 }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography
            variant="caption"
            align="center"
            sx={{ color: active ? "white" : "text.secondary"}}
          >
            {subtitle}
          </Typography>
        )}
      </CenteredBox>
    </Paper>
  );
};

export default Counts;
